// #915 — pure helpers for recovering from a failed lazy-route chunk fetch.
// Kept out of RouteError.tsx so that file exports components only (matching
// the repo's react-refresh convention) and so the reload guard is unit-testable
// without a router.

const RELOAD_KEY = 'geniac:chunk-reload-at';
const RELOAD_COOLDOWN_MS = 15_000;

/** True when we may auto-reload, at most once per cooldown window. */
export function claimChunkReload(now: number = Date.now()): boolean {
  try {
    const raw = sessionStorage.getItem(RELOAD_KEY);
    // No prior reload this session → always allowed, regardless of `now`.
    if (raw !== null && now - Number(raw) < RELOAD_COOLDOWN_MS) return false;
    sessionStorage.setItem(RELOAD_KEY, String(now));
    return true;
  } catch {
    // Private mode / storage disabled — avoid reload loops, just show the UI.
    return false;
  }
}

export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  return /dynamically imported module|Importing a module script failed|ChunkLoadError/i.test(
    message,
  );
}
